import { defineComponent as _defineComponent } from 'vue'
import type VueI18n from 'vue-i18n';
import IconAlert from '@white-label-icon/icon-alert';

interface ErrorMessageProps {
  html?: string | string[] | VueI18n.TranslateResult;
  message?: string | VueI18n.TranslateResult;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'error-message',
  props: {
    html: { default: '' },
    message: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true,IconAlert }
}

})